module.exports = __webpack_public_path__ + "img/orng_4.389d2afb.jpg";